
import { Record, Union } from "../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, option_type, bool_type, class_type, string_type, union_type } from "../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { ValidationResponse_$reflection, FormState_$reflection } from "../Shared/Shared.js";

export class Step extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Welcome", "Categories", "Details", "Done"];
    }
}

export function Step_$reflection() {
    return union_type("OnboardingWizard.Types.Step", [], Step, () => [[], [], [], []]);
}

export class State extends Record {
    constructor(Step, SelectedCategories, OtherCategorySelected, OtherCategoryText, NumberOfEmployees, NumberOfTools, WantsOverview, WantsReduceToolLoss, WantsInspections, WantsCostControl, WantsProcessOptimization, WantsInternalCommunication, OtherProblemSelected, OtherProblemText, CurrentSolution, CurrentSolutionSoftwareText, CurrentSolutionOtherText, FormState, OnWizardCompleted) {
        super();
        this.Step = Step;
        this.SelectedCategories = SelectedCategories;
        this.OtherCategorySelected = OtherCategorySelected;
        this.OtherCategoryText = OtherCategoryText;
        this.NumberOfEmployees = NumberOfEmployees;
        this.NumberOfTools = NumberOfTools;
        this.WantsOverview = WantsOverview;
        this.WantsReduceToolLoss = WantsReduceToolLoss;
        this.WantsInspections = WantsInspections;
        this.WantsCostControl = WantsCostControl;
        this.WantsProcessOptimization = WantsProcessOptimization;
        this.WantsInternalCommunication = WantsInternalCommunication;
        this.OtherProblemSelected = OtherProblemSelected;
        this.OtherProblemText = OtherProblemText;
        this.CurrentSolution = CurrentSolution;
        this.CurrentSolutionSoftwareText = CurrentSolutionSoftwareText;
        this.CurrentSolutionOtherText = CurrentSolutionOtherText;
        this.FormState = FormState;
        this.OnWizardCompleted = OnWizardCompleted;
    }
}

export function State_$reflection() {
    return record_type("OnboardingWizard.Types.State", [], State, () => [["Step", Step_$reflection()], ["SelectedCategories", class_type("Microsoft.FSharp.Collections.FSharpSet`1", [string_type])], ["OtherCategorySelected", bool_type], ["OtherCategoryText", string_type], ["NumberOfEmployees", option_type(string_type)], ["NumberOfTools", option_type(string_type)], ["WantsOverview", bool_type], ["WantsReduceToolLoss", bool_type], ["WantsInspections", bool_type], ["WantsCostControl", bool_type], ["WantsProcessOptimization", bool_type], ["WantsInternalCommunication", bool_type], ["OtherProblemSelected", bool_type], ["OtherProblemText", string_type], ["CurrentSolution", option_type(string_type)], ["CurrentSolutionSoftwareText", string_type], ["CurrentSolutionOtherText", string_type], ["FormState", FormState_$reflection()], ["OnWizardCompleted", lambda_type(unit_type, unit_type)]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["StartWizard", "SetCategory", "ToggleOtherCategory", "SetOtherCategoryText", "SetNumberOfEmployees", "SetNumberOfTools", "ToggleOverview", "ToggleToolLoss", "ToggleInspections", "ToggleCostControl", "ToggleProcessOptimization", "ToggleInternalCommunication", "ToggleOtherProblem", "SetOtherProblemText", "SetCurrentSolution", "SetCurrentSolutionSoftwareText", "SetCurrentSolutionOtherText", "NextStep", "BackStep", "Submit", "SubmitSucceeded", "SubmitFailed", "FinishDone"];
    }
}

export function Msg_$reflection() {
    return union_type("OnboardingWizard.Types.Msg", [], Msg, () => [[], [["Item1", string_type], ["Item2", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [], [], [], [], [["Item", ValidationResponse_$reflection()]], []]);
}

